import React from 'react';
import { Button, Text, Input, Select } from 'v3/components';
import { CNPJ_MASK } from 'v3/utils/masks';

import { STATUS_NAMES, STATUS_ORDER } from '../../shared/status';

import { Actions, Container, Field } from './styles';

export default function ShippingCompanyRequestFilter({
  loading,
  filters,
  setFilters,
  onFilter,
  onClear,
}) {
  function handleChange(field) {
    return ({ target }) => setFilters((prev) => ({ ...prev, [field]: target.value }));
  }

  const statusOptions = STATUS_ORDER.map((slug) => ({ value: slug, label: STATUS_NAMES[slug] }));
  const selectedStatus =
    statusOptions.find((option) => option.value === filters.statusSlug) || null;

  function handleKeyDown(event) {
    if (event.key === 'Enter' && !loading) {
      onFilter();
    }
  }

  return (
    <Container style={{ marginBottom: '4rem' }}>
      <Field minWidth="220px">
        <Input
          label="CNPJ da transportadora"
          labelColor="#fff"
          masked
          mask={CNPJ_MASK}
          value={filters.shippingDocument}
          onChange={handleChange('shippingDocument')}
          onKeyDown={handleKeyDown}
          placeholder="Filtrar por CNPJ"
        />
      </Field>

      <Field minWidth="240px">
        <Input
          label="E-mail"
          labelColor="#fff"
          value={filters.email}
          onChange={handleChange('email')}
          onKeyDown={handleKeyDown}
          placeholder="Filtrar por e-mail"
        />
      </Field>

      <Field minWidth="200px">
        <Input
          label="CPF do usuário"
          labelColor="#fff"
          value={filters.userDocument}
          onChange={handleChange('userDocument')}
          onKeyDown={handleKeyDown}
          placeholder="Filtrar por CPF"
        />
      </Field>

      <Field minWidth="280px" data-testid="filter-status">
        <Select
          id="filter-status"
          label="Status"
          labelTextColor="#fff"
          placeholder="Todos os status"
          options={statusOptions}
          value={selectedStatus}
          onChange={(option) =>
            setFilters((prev) => ({ ...prev, statusSlug: option?.value || '' }))
          }
          disableSearch
          useMenuPortal
        />
      </Field>

      <Actions>
        <Button variant="primary" loading={loading} disabled={loading} onClick={onFilter}>
          <Text color="white" weight={500}>
            Filtrar
          </Text>
        </Button>
        <Button variant="secondary" disabled={loading} onClick={onClear}>
          <Text color="dark" weight={500}>
            Limpar
          </Text>
        </Button>
      </Actions>
    </Container>
  );
}
